import {
  Pipe,
  PipeTransform
} from '@angular/core';

@Pipe({
  standalone: true,
  name: 'time'
})
export class TimePipe implements PipeTransform {
  transform(value: number): string {
    const hours = Math.floor(value / 60).toLocaleString(undefined, { minimumIntegerDigits: 2 });
    const minutes = Math.floor(value % 60).toLocaleString(undefined, { minimumIntegerDigits: 2 });
    return `${hours}H${minutes}`;
  }
}
